import { CmsComponent } from './cms/cms.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { LocationComponent } from './location/location.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {SkillsComponent} from './skills/skills.component';
// import { CategoryComponent } from '../category/category.component';
import { Category1Component } from './category1/category1.component';
import { UsersComponent } from './users1/users.component';
import { AddUsersComponent } from './users1/addusers.component';
import { CollabosComponent } from './collabos/collabos.component';
import { AdminSignupComponent } from './admin-signup/admin-signup.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RolesComponent } from './roles/roles.component';
import { AdminprofileComponent } from './adminprofile/adminprofile.component';
import { EmailComponent } from './email/email.component';
import { PlansComponent } from './plans/plans.component';

const routes: Routes = [
    {
      path: 'admin',
      component: AdminComponent,

     children: [
        {
          path: 'location', // child route path
          component: LocationComponent, // child route component that the router renders
          data: {
            title: 'Location'
          },
        },
         {
          path: 'adminprofile', // child route path
          component: AdminprofileComponent, // child route component that the router renders
          data: {
            title: 'AdminProfile'
          },
        },
        {
          path: 'dashboard', // child route path
          component: DashboardComponent, // child route component that the router renders
          data: {
            title: 'Dashboard'
          },
        },
        {
          path:'skills',
          component:SkillsComponent,
          data: {
            title: 'Skills'
          },
        },
        {
          path:'category',
          component:Category1Component,
          data: {
            title: 'Category'
          },
        },
        {
          path:'users',
          component:UsersComponent,
          data: {
            title: 'Users'
          },
        },
       
        {
          path:'addusers',
          component:AddUsersComponent,
          data: {
            title: 'Addusers'
          },
        },
        {
          path:'collabos',
          component:CollabosComponent,
          data: {
            title: 'Collabos'
          },
        },
         {
          path:'admin-signup',
          component:AdminSignupComponent,
          data: {
            title: 'AdminSignup'
          },
        },
        {
          path:'roles',
          component:RolesComponent,
          data: {
            title: 'Roles'
          },
        },
        {
          path:'cms',
          component:CmsComponent,
          data: {
            title: 'CMS'
          },
        },
         {
          path:'changepassword',
          component:ChangePasswordComponent,
          data: {
            title: 'ChangePassword'
          },
        },
        {
          path:'emails',
          component:EmailComponent,
          data: {
            title: 'Emails'
          },
        },
{
          path:'plans',
          component:PlansComponent,
          data: {
            title: 'Plans'
          },
      }
        
      ],
    },
  ];
  
      @NgModule({
    imports: [ RouterModule.forChild(routes), RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AdminRoutingModule {}
